"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteFileAssetSchema = exports.listFileAssetsSchema = exports.uploadFileAssetSchema = exports.fileAssetKind = void 0;
const zod_1 = require("zod");
exports.fileAssetKind = zod_1.z.enum(["porting_loa", "porting_bill", "greeting_audio"]);
exports.uploadFileAssetSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    kind: exports.fileAssetKind,
    label: zod_1.z.string().max(255).optional(),
    entityType: zod_1.z.enum(["auto_attendant", "mailbox"]).optional(),
    entityId: zod_1.z.string().uuid().optional(),
    filename: zod_1.z.string().min(1).max(255),
    mimeType: zod_1.z.string().min(1).max(127),
    dataBase64: zod_1.z.string().min(1),
});
exports.listFileAssetsSchema = zod_1.z.object({
    projectId: zod_1.z.string().uuid(),
    kind: exports.fileAssetKind.optional(),
});
exports.deleteFileAssetSchema = zod_1.z.object({ id: zod_1.z.string().uuid() });
